/* Boni — guided-journey step popup ("game tutorial" style, user request 2026-08-28).
   HAND-WRITTEN asset, NOT built from JSX by scripts/build-web.sh. Styles live in
   boni-store.css under .bsg-*; the mascot is guide-dog-v1.webp served via window.K
   (defined in theme.liquid's <head>). Loaded on every page by theme.liquid.

   WHEN IT SHOWS — all four must hold:
     1. sessionStorage.boniGuided === '1'  — set ONLY by the ?pas= handoff script in
        theme.liquid, i.e. this browsing SESSION came through the wizard. A returning
        visitor who merely still has a dog name in localStorage sees nothing (user
        request: "not always when you are on the food page, only when you came there
        after clicking wizard"). sessionStorage is per-tab and dies with it, which is
        exactly the lifetime of one guided journey.
     2. Not dismissed this session (sessionStorage.boniGuideDismissed). Dismissal is
        SESSION-scoped on purpose: a future wizard re-run is a new guided journey and
        gets its guide again. (The old persistent boni_plan.guideDismissed key from the
        first iteration is deliberately ignored.)
     3. A dog name exists in localStorage boni_plan (nominative-only rule: the name is
        shown alone as a chip, never declined — S74/S75).
     4. The page is a step in the journey: /collections/* -> KORAK 1 (choose a food),
        /products/* -> KORAK 2 (turn on the delivery plan). Cart/checkout/home: nothing.

   SECURITY NOTE: the dog name originates from a URL param (?pas=), so it is
   attacker-shapeable via a crafted link. It is inserted with textContent ONLY —
   never concatenate it into innerHTML. */
(function () {
  function run() {
    try {
      if (sessionStorage.getItem('boniGuided') !== '1') return;
      if (sessionStorage.getItem('boniGuideDismissed') === '1') return;

      var plan = {};
      try { plan = JSON.parse(localStorage.getItem('boni_plan') || '{}') || {}; } catch (e) {}
      var dog = (plan.dog || '').trim();
      if (!dog) return;

      var path = window.location.pathname;
      var step = null;
      if (path.indexOf('/products/') !== -1) {
        /* copy updated 2026-08-28: the PDP weight helper was removed (plan-vs-once
           redesign), so the old "Upiši kilažu" instruction pointed at nothing. */
        step = { pill: 'Korak 2', title: 'Uključi plan dostave.', sub: 'Članstvo dolazi s njim, besplatno.' };
      } else if (path.indexOf('/collections/') !== -1) {
        step = { pill: 'Korak 1', title: 'Odaberi hranu.', sub: 'Koliko i kako često, složimo mi.' };
      }

      /* KORAK 3 lives INSIDE the cart drawer, above the checkout button, on desktop
         and phone alike (2026-09-01). Not floating like 1 and 2, deliberately: the
         drawer is a modal over a scrim, so a card outside it would sit on dimmed page
         and read as switched off, and on a phone the drawer is full-screen so a fixed
         bottom card would cover the very button it points at. Recognisability comes
         from the CARD (same mascot, pill, bubble, X), not from the coordinates. */
      var CART_STEP = { pill: 'Korak 3', title: 'Dovrši narudžbu.',
                        sub: 'Na naplati upiši broj mobitela, tamo ti se Boni javi.' };

      function build(st, inline) {
        var wrap = document.createElement('div');
        wrap.className = inline ? 'bsg bsg--inline bsg-on' : 'bsg';
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-label', 'Vodič kroz korake');

        var avatar = document.createElement('img');
        avatar.className = 'bsg-avatar';
        avatar.src = (window.K || '') + 'guide-dog-v1.webp';
        avatar.alt = '';
        avatar.width = 72; avatar.height = 72;

        var card = document.createElement('div');
        card.className = 'bsg-card';

        var top = document.createElement('div');
        top.className = 'bsg-top';

        var pill = document.createElement('span');
        pill.className = 'bsg-pill';
        pill.textContent = st.pill;

        var name = document.createElement('span');
        name.className = 'bsg-name';
        name.textContent = dog; /* textContent, never innerHTML — see security note */

        var x = document.createElement('button');
        x.className = 'bsg-x';
        x.setAttribute('aria-label', 'Zatvori vodič');
        x.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        x.addEventListener('click', function () {
          try { sessionStorage.setItem('boniGuideDismissed', '1'); } catch (e) {}
          dismissed = true;
          removeAll();
        });

        top.appendChild(pill); top.appendChild(name); top.appendChild(x);

        var title = document.createElement('div');
        title.className = 'bsg-title';
        title.textContent = st.title;

        var sub = document.createElement('div');
        sub.className = 'bsg-sub';
        sub.textContent = st.sub;

        card.appendChild(top); card.appendChild(title); card.appendChild(sub);
        wrap.appendChild(avatar); wrap.appendChild(card);
        return wrap;
      }

      var dismissed = false;
      function removeAll() {
        var all = document.querySelectorAll('.bsg');
        Array.prototype.forEach.call(all, function (e) {
          if (e.parentNode) e.parentNode.removeChild(e);
        });
      }
      function pageCard() { return document.querySelector('.bsg:not(.bsg--inline)'); }

      /* --- the floating step for this page (1 or 2) --- */
      if (step) {
        var wrap = build(step, false);
        document.body.appendChild(wrap);
        /* Delayed entrance: a thing that visibly ARRIVES reads as a message; a thing
           that was always there reads as the website. */
        setTimeout(function () { wrap.className = 'bsg bsg-on'; }, 500);
      }

      /* --- KORAK 3, attached to the drawer --- */
      function mountCartStep() {
        if (dismissed) return;
        var foot = document.querySelector('#bc-drawer .bc-foot');
        if (!foot) return;                                  /* empty cart: no step */
        if (foot.querySelector('.bsg--inline')) return;     /* already there */
        /* directly ON TOP of the checkout button, below the totals: the instruction
           should touch the control it names, and it keeps the guide's dog away from
           Boni's own avatar in the note card above */
        foot.insertBefore(build(CART_STEP, true), foot.querySelector('form') || null);
      }
      function unmountCartStep() {
        var el = document.querySelector('.bsg--inline');
        if (el && el.parentNode) el.parentNode.removeChild(el);
      }

      document.addEventListener('boni:cart-open', function () {
        /* hide the page step while the drawer is up: it would sit on the dimmed
           scrim, and two guide cards on screen is two instructions at once */
        var pc = pageCard(); if (pc) pc.style.display = 'none';
        mountCartStep();
      });
      document.addEventListener('boni:cart-render', mountCartStep);
      document.addEventListener('boni:cart-close', function () {
        unmountCartStep();
        var pc = pageCard(); if (pc && !dismissed) pc.style.display = '';
      });

      /* the /cart page has no drawer, so the step attaches to the page footer there */
      if (path.indexOf('/cart') !== -1) {
        var pf = document.querySelector('.bc-page .bc-foot');
        if (pf) pf.insertBefore(build(CART_STEP, true), pf.querySelector('form') || null);
      }
    } catch (e) { /* the guide is a nicety, never break the page */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
